'use client';

import dynamic from 'next/dynamic';

interface GalleryWrapperProps {
  isDevelopment?: boolean;
}

const Gallery = dynamic(() => import('./Gallery'));

const GalleryWrapper = ({ isDevelopment = false }: GalleryWrapperProps) => {
  return <Gallery isDevelopment={isDevelopment} />;
};

export default GalleryWrapper;
